<script>
    // library for creating dropdown menu appear on click
    import { createPopper } from "@popperjs/core";
    import { navigate } from "svelte-routing";
    import { link } from "svelte-routing";
    import { removeKeys } from "../../services/authService";
    import { loggedUser } from "../../stores/settingsStore";
    // core components

    const image = "../assets/img/team-1-800x800.jpg";

    let dropdownPopoverShow = false;

    let btnDropdownRef;
    let popoverDropdownRef;

    const toggleDropdown = (event) => {
        event.preventDefault();
        if (dropdownPopoverShow) {
            dropdownPopoverShow = false;
        } else {
            dropdownPopoverShow = true;
            createPopper(btnDropdownRef, popoverDropdownRef, {
                placement: "bottom-start",
            });
        }
    };

    function handleLogout() {
      removeKeys();
      $loggedUser = null;
      navigate("/auth", { replace: true })
    }
</script>

<div>
    <a
        class="text-blueGray-500 block"
        href="#"
        bind:this="{btnDropdownRef}"
        on:click="{toggleDropdown}"
    >
        <div class="items-center flex">
            <span class="w-12 h-12 text-sm text-white border inline-flex items-center justify-center rounded-full">
                <i class="fa fa-user"></i>
            </span>
        </div>
    </a>

    <div bind:this="{popoverDropdownRef}"
         class="bg-white text-base float-left py-2 px-4 list-none text-left rounded shadow-lg min-w-48 {dropdownPopoverShow ? 'block':'hidden'}">

        <div>{$loggedUser.email}</div>

        <hr class="my-2">

        <a
            use:link
            href="/admin/profile"
            on:click={(e) => e.preventDefault()}
            class="font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700"
        >
            Profilo
        </a>
        <hr class="my-2">
        <button on:click|preventDefault={() => handleLogout()}
                class="text-left font-normal block w-full whitespace-nowrap bg-transparent text-red-600 outline-none focus:outline-none">
            Logout
        </button>
    </div>
</div>

